import { poiTypes } from "../lib/open-planet/poiTypes";
import resourceTypes from "../lib/open-planet/resourceTypes";
import constants from "../lib/constants";

const {
  sights,
  eating,
  shopping,
  drinking_nightlife,
  entertainment,
  transport,
  info,
  festivals_events,
  sleeping,
} = poiTypes;
const { AJAX_PATH } = constants;

const userFriendlySlug = ":slug(*)";

const {
  pa,
  poi,
  art,
  lod,
  col,
  nar,
} = {
  pa: "pa",
  poi: "poi",
  art: "art",
  lod: "lod",
  col: "col",
  nar: "nar",
};

export const RESOURCE_MAP = {
  [pa]: resourceTypes.partner_activity,
  [poi]: resourceTypes.poi,
  [art]: resourceTypes.articles,
  [lod]: resourceTypes.lodging,
  [col]: resourceTypes.collections,
  [nar]: resourceTypes.narratives,
};

export const RESOURCE_ABBREV_MAP = {
  [resourceTypes.partner_activity]: pa,
  [resourceTypes.poi]: poi,
  [resourceTypes.articles]: art,
  [resourceTypes.lodging]: lod,
  [resourceTypes.collections]: col,
  [resourceTypes.narratives]: nar,
};

const {
  sig,
  eat,
  sho,
  dri,
  ent,
  tra,
  inf,
  fes,
  act,
  tou,
  sle,
} = {
  sig: "sig",
  eat: "eat",
  sho: "sho",
  dri: "dri",
  ent: "ent",
  tra: "tra",
  inf: "inf",
  fes: "fes",
  act: "act",
  tou: "tou",
  sle: "sle",
};

export const RESOURCE_KIND_MAP = {
  [sig]: sights.name,
  [eat]: eating.name,
  [sho]: shopping.name,
  [dri]: drinking_nightlife.name,
  [ent]: entertainment.name,
  [tra]: transport.name,
  [inf]: info.name,
  [fes]: festivals_events.name,
  [sle]: sleeping.name,
  [act]: "activities",
  [tou]: "tours",
};

export const RESOURCE_KIND_ABBREV_MAP = {
  [sights.name]: sig,
  [eating.name]: eat,
  [shopping.name]: sho,
  [drinking_nightlife.name]: dri,
  [entertainment.name]: ent,
  [transport.name]: tra,
  [info.name]: inf,
  [festivals_events.name]: fes,
  [sleeping.name]: sle,
  activities: act,
  tours: tou,
};

export const USER_FRIENDLY_MAP = {
  [RESOURCE_KIND_MAP.sig]: sights.displayName.toLowerCase(),
  [RESOURCE_KIND_MAP.eat]: eating.displayName.toLowerCase(),
  [RESOURCE_KIND_MAP.sho]: shopping.displayName.toLowerCase(),
  [RESOURCE_KIND_MAP.dri]: drinking_nightlife.displayName.toLowerCase(),
  [RESOURCE_KIND_MAP.ent]: entertainment.displayName.toLowerCase(),
  [RESOURCE_KIND_MAP.tra]: transport.displayName.toLowerCase(),
  [RESOURCE_KIND_MAP.inf]: info.displayName.toLowerCase(),
  [RESOURCE_KIND_MAP.fes]: festivals_events.displayName.toLowerCase(),
  [RESOURCE_KIND_MAP.sle]: sleeping.displayName.toLowerCase(),
  [RESOURCE_KIND_MAP.act]: "activities",
  [RESOURCE_KIND_MAP.tou]: "tours",
  [RESOURCE_MAP.lod]: "hotels",
  [RESOURCE_MAP.poi]: "top-things-to-do",
  [RESOURCE_MAP.col]: "collections",
  [RESOURCE_MAP.nar]: "narratives",
};

export const QUERY_STRING_FILTERS = {
  duration: "duration",
  endDate: "endDate",
  exists: "exists",
  facilities: "facilities",
  from: "from",
  fromPrice: "fromPrice",
  locations: "locations",
  numNights: "numNights",
  price: "price",
  startDate: "startDate",
  subtypes: "subtypes",
  to: "to",
  toPrice: "toPrice",
};

export const NAR_DETAIL_SHOW = `${userFriendlySlug}/${AJAX_PATH}/nar/:id/:placeId(\\d+)`;
export const NAR_GROUP_DETAIL_SHOW = `${userFriendlySlug}/${AJAX_PATH}/nar\-gr/:id/:placeId(\\d+)`;
export const COL_DETAIL_SHOW = `${userFriendlySlug}/${AJAX_PATH}/col/:id([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/:placeId(\\d+)`;
export const COL_LIST_SHOW = `${userFriendlySlug}/${AJAX_PATH}/col/:narrative_path(*?)/:placeId(\\d+)`;

export const LIST_SHOW = `${userFriendlySlug}/${AJAX_PATH}/:resource([a-z]+)\-?:kind?/:placeId\.:ext?`;
export const DETAIL_SHOW = `${userFriendlySlug}/${AJAX_PATH}/:resource(${poi}|${lod}|${art}|${col})\-?:kind?/:id/:placeId\.:ext?`;
export const PA_DETAIL_SHOW = `${userFriendlySlug}/${AJAX_PATH}/:resource(${pa})\-:kind(tou|act)/:id/:placeId\.:ext?`;



// WEBPACK FOOTER //
// ../server/routes/constants.js